// view layer에 특화된 데이터를 api request에 특화된 데이터로 변경 한다.
// 예를 들면 프론트에서는 시간을 00:00 으로 하는데 서버는 0000 이다
// formData와 domain-model에서는 00:00으로만 핸들링 하고
// service에 보내기 직전에 serviceData 레이어에서 00:00을 0000으로
// 치환하는 등의 액션을 한다
// 또는 프론트레이어에서는 yyyy-mm-dd로 핸들링 하는데
// 백에 unixtime으로 전달하는 등의 로직을 이곳에서 처리한다
// 프론트 데이터를 받아서 이곳에서 백엔드 데이터로 가공 한다.
// 이후 해당 데이터들을 이용해서 requestData 메서드로 api 쏠 때 필요한 데이터로
// 가공 한다.
// formData와 필요한 추가 데이터를 받아 핸들링 한다
// eslint-disable-next-line import/prefer-default-export
export class ServiceData {
}
